<button 
  class="pill-tab-button"
  [ngStyle]="pillStyles | theme"
  (click)="onClick()">
  {{ label }}
</button>
